import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { systemStatusQuery } from '@/features/system/system-api';
import { SystemScreen } from '@/features/system/system-screen';
import { meQuery } from '@/lib/queries';

export const Route = createFileRoute('/_app/settings/status')({
  loader: ({ context }) => context.queryClient.ensureQueryData(systemStatusQuery),
  component: SystemRoute,
});

function SystemRoute() {
  const { data: me } = useSuspenseQuery(meQuery);
  const { data: status, dataUpdatedAt } = useSuspenseQuery(systemStatusQuery);
  return <SystemScreen status={status} fetchedAt={dataUpdatedAt} isAdmin={me.user.role === 'admin'} />;
}
